import LocalizedString from './LocalizedString';

export default class SliderLabel {
  public minimumLabel: LocalizedString;

  public maximumLabel: LocalizedString;

  constructor(labels: any) {
    this.minimumLabel = new LocalizedString(labels.min_label);

    this.maximumLabel = new LocalizedString(labels.max_label);
  }
}
